<script>
	import API from '../../States/API';
	import Config from '../../Models/Config';
	import Helper from '../../Models/Helper';
	import Session from '../../States/Session';
	import Slider from '../../States/Slider';
	import Validation from './Password/Validation.svelte';

	export let index = 0;

	let slide = {};
	let pass = {};
	let requested = false;
	let success = false;
	let active = false;

	async function verify(event) {
		requested = true;
		const data = Helper.form(event.target);
		data.token = slide.code;
		const response = await API.verifyPassword(data);
		success = response.success;
	}

	function updateSlider(slides) {
		slide = slides[`slide_${index}`].properties;
		active = slide.active;
	}

	Slider.subscribe(updateSlider);
</script>

<style>
	div.panel {
		display: flex;
		justify-content: space-between;
		margin-bottom: 3em;
	}

	div.panel .button {
		margin-bottom: 0;
	}

	div.panel.forgot {
		margin-bottom: 1.5em;
	}

	div.panel.forgot input {
		width: calc(75% - .5em);
	}

	div.panel.forgot .button {
		width: calc(25% - .5em);
	}

	@media (max-device-width: 1024px) {
		div.panel {
			flex-direction: column;
		}

		div.panel .button,
		div.panel input {
			width: 100% !important;
			margin-bottom: .5em;
		}

		div.panel .button {
			padding-top: 1em;
			padding-bottom: 1em;
		}
	}
</style>

<div class="box feature" class:active>
	<div class="menu">
		<div class="begin">
			<div class="title">Wachtwoord Wijzigen</div>
		</div>
		<div class="end">
			<div class="item" on:click="{event => Slider.close()}">
				<i class="fas fa-times"></i>
			</div>
		</div>
	</div>
	<div class="content">
		{#if !requested}
			<h1>Wachtwoord Wijzigen</h1>
			<p>Voer hieronder een nieuw wachtwoord in.</p>
			<form name="verify_form" on:submit|preventDefault="{verify}">
				<div class="panel forgot">
					<input bind:this="{pass}" type="password" name="pass" required="required" placeholder="Wachtwoord"/>
					<button class="button primary solid" type="submit" disabled="{$API.busy}">
						<i class="fad fa-key"></i> Wijzigen
					</button>
				</div>
			</form>
			<Validation pass="{pass}"/>
		{:else}
			{#if $API.busy}
				<h1>Wachtwoord Wijzigen</h1>
				<p>Een moment geduld. Jouw wachtwoord wordt gewijzigd...</p>
			{:else if !$API.busy && success}
				<h1>Wijziging gelukt!</h1>
				<p>Je kunt nu inloggen via de onderstaande knop.</p>
				<div class="button primary solid proceed" on:click="{event => Slider.route('signIn')}">
					<i class="fad fa-chevron-right"></i> Inloggen
				</div>
			{:else if !$API.busy && !success}
				<h1>Er is een fout opgetreden.</h1>
				<p>Jouw wachtwoord kan helaas niet bevestigd worden.</p>
				<a class="button primary solid proceed" href="/start">
					<i class="fad fa-chevron-right"></i> Verder
				</a>
			{/if}
		{/if}
	</div>
</div>